module.exports = __webpack_public_path__ + "img/no-image.634dafd1.png";